/**
 * filter null/undefined & declare type is non-nullable
 * useful in filters over arrays with nullable values
 * [1, 2, 0, null, undefined].filter(isNonNullable) // number[]
 */
export function isNonNullable<T>(value: T): value is NonNullable<T> {
  return value != null;
}
